import { Injectable }     from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { PlatformService } from './platform.service';

declare let window: any;

@Injectable()
export class TrackerService {
  mixpanel: any;

  constructor(
    private platformService: PlatformService
  ) {
    this.mixpanel = window.lucybot.tracker ? {track: window.lucybot.tracker} : window.mixpanel;
  }

  track(name, details:any={}) {
    if (!this.mixpanel || this.platformService.isServer) return;
    this.mixpanel.track(name, details);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/tracker.ts